<div class="header" [ngClass]="color" (click)="toggle.emit()">
  <ng-content select=".accordian-header"></ng-content>
  <svg class="icon" [ngClass]="{'open': opened}">
    <use xlink:href="/assets/img/sprite.svg?v1.7#arrow-collapse-icon"></use>
  </svg>
</div>
<div class="content" [class.hidden]="!opened" [ngClass]="color">
  <ng-content></ng-content>
</div>